import "../../../index61.css";
import { jsx as o, Fragment as F } from "react/jsx-runtime";
import { Fragment as T } from "react";
import { _ as w } from "../../../cs-piwRuCFZ.js";
import "../../../type-BFTbooL7.js";
import k from "../TableData/index.js";
import z from "../TableRow/index.js";
const P = "_row_1829z_1", j = "_cell_1829z_2", d = {
  row: P,
  cell: j
};
function q(_) {
  const {
    data: l,
    keySelector: y,
    columns: t,
    rowClassName: n,
    cellClassName: s,
    rowModifier: a
  } = _;
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ o(F, { children: l == null ? void 0 : l.map((e, m) => {
      const r = y(e, m), i = t.map((N) => {
        const {
          id: c,
          cellRenderer: C,
          cellRendererClassName: R,
          cellRendererParams: h,
          cellContainerClassName: u
        } = N, b = h(r, e, m, l), g = /* @__PURE__ */ o(
          C,
          {
            className: R,
            ...b,
            name: c
          }
        );
        return /* @__PURE__ */ o(
          k,
          {
            className: w(
              d.cell,
              u,
              typeof s == "function" ? s(r, e, c) : s
            ),
            children: g
          },
          c
        );
      }), f = /* @__PURE__ */ o(
        z,
        {
          className: w(
            d.row,
            typeof n == "function" ? n(r, e) : n
          ),
          children: i
        }
      );
      let p = f;
      return a && (p = a({
        rowKey: r,
        row: f,
        cells: i,
        columns: t,
        datum: e
      })), /* @__PURE__ */ o(
        T,
        {
          children: p
        },
        r
      );
    }) })
  );
}
export {
  q as default
};
